import { AddCustomerVehicleResponseModel } from '../business-entities/add-customer-vehicle-response.interface';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Injectable } from '@angular/core';
import { Urls } from './../utils/urls';
import { MobileValidationModel } from '../business-entities/mobile-number-validation.interface';
import { CreateContactRequestModel } from '../business-entities/create-contact-request-model';
import { ClientAppLogout } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Injectable({providedIn: 'root'})
export class FindCarDataService {
    constructor(
        private dataService: DataService
    ) {}

    getCustomerAndVehicleDetails(licensePlate: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetCustomerAndVehicleDetails, licensePlate).toPromise();
    }

    getCustomerAndVehicleDetailsUsingMobile(mobileNo: string,mobileCode:string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetCustomerVehiclesByMobileNo, mobileNo,mobileCode).toPromise();
    }

    getBrandDetais(): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetBrandList).toPromise();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>>{
      return this.dataService.Get<GenericResponse<any>>(Urls.GetCountryCodeAndMobileCodeDetails).toPromise();
    }

    getFuelTypeDetails(): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetFuelTypeDetails).toPromise();
    }

    getVehicleTypes(): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetVehicleTypes).toPromise();
    }

    checkCustomerDetails(model: MobileValidationModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.CheckCustomerAvailable, model).toPromise();
    }

    AddCustomerVehicleDetails(model: AddCustomerVehicleResponseModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.AddCustomerVehicleDetails, model).toPromise();
    }
    AddCustomerMobile(model: any): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.AddCustomerMobile, model).toPromise();
    }
    getVehicleDetailsByVehicleno(vehicleNo: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.getVehicleDetailsByVehicleno, vehicleNo).toPromise();
    }
    getVehicleDetailsFromDMSByVehicleno(vehicleNo: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.getVehicleDetailsFromDMSByVehicleno, vehicleNo).toPromise();
    }
    AddMobileOTPDetails(model: any): Promise<GenericResponse<any>> {
        ClientAppLogout();
        return this.dataService.Post<GenericResponse<any>>(Urls.AddMobileOTPDetails, model).toPromise();
    }
    async GetVehicleTransmissionDropdownList(): Promise<any> {
        return this.dataService.Get<any>(Urls.GetVehicleTransmissionDropdownList).toPromise();
    }
    async GetModelnoDropdownList(make:string): Promise<any> {
        return this.dataService.Get<any>(Urls.GetModelnoDropdownList,make).toPromise();
    }
    GetVehicleByLicensePlateNoOrVIN(licensePlateNo: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetVehicleByLicensePlateNoOrVIN, licensePlateNo).toPromise();
    }
    CreateContact(model: CreateContactRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.CreateContact, model).toPromise();
    }
    AssignDriverToVehicle(vehicleId: string, driverId: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.AssignDriverToVehicle, vehicleId, driverId).toPromise();
    }
}
